const localTimeZone = 'America/Los_Angeles'; //standardized TZ name for eastern US time

//Get the day standardized to Eastern US time (UTC -4)
export function getDateLocalTime(date: Date): number {
    let shiftedDateString = date.toLocaleString('en-US', { timeZone: localTimeZone });
    let shiftedDate = new Date(shiftedDateString);

    return shiftedDate.getDate();
}
